import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useProducts } from "@/hooks/useProducts";

const SLUG = "cure-3-mois-8-soins";
const eur = (n) => `${Number(n).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} €`;

export function CureBanner({ testid = "cure-banner", className = "" }) {
  const { data } = useProducts();
  const cure = (Array.isArray(data) ? data : []).find((p) => p.slug === SLUG);
  if (!cure) return null;
  const saving = cure.compare_at ? cure.compare_at - cure.price : 0;
  return (
    <section data-testid={testid} className={className}>
      <div className="mx-auto grid max-w-6xl items-center gap-6 overflow-hidden rounded-sm border border-[var(--gold)]/50 bg-[var(--ink-2)] md:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)]">
        <img src={cure.image} alt={cure.name} loading="lazy" width="1264" height="844" className="aspect-[3/2] w-full object-cover" />
        <div className="p-6 md:p-8">
          <p className="eyebrow mb-3">Pack Ozentya · 8 soins</p>
          <h2 className="font-display text-3xl leading-tight md:text-4xl">Cure 3 mois <span className="italic gold-text">Optimal</span></h2>
          <p className="mt-3 text-sm leading-relaxed text-[var(--parchment)]/85">2 Masques Suprême, 2 Crèmes Cactus, 2 Shampoings Cactus et 2 Extrême Repouss pour suivre votre routine pendant 3 mois.</p>
          <p className="mt-5 flex flex-wrap items-baseline gap-3">
            <span data-testid={`${testid}-price`} className="font-display text-4xl text-[var(--gold-soft)]">{eur(cure.price)}</span>
            {cure.compare_at ? <span data-testid={`${testid}-compare`} className="text-base text-[var(--parchment)]/75 line-through">au lieu de {eur(cure.compare_at)}</span> : null}
          </p>
          {saving > 0 ? <p data-testid={`${testid}-saving`} className="mt-2 text-xs uppercase tracking-[0.2em] text-[var(--gold-soft)]">{eur(saving)} d'économie</p> : null}
          <Link to={`/produit/${SLUG}`} data-testid={`${testid}-cta`}
            className="group mt-6 inline-flex h-12 items-center gap-2 rounded-full bg-[var(--gold)] px-7 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ink)] transition-colors duration-300 hover:bg-[var(--gold-soft)]">
            Découvrir la cure <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
